import { useRouteError } from "react-router-dom-7"
import { ErrorMessage } from "~/shared/ui/components/errors/ErrorMessage"
import { AccessError } from "../AccessError"
import { AccessErrorMessage } from "./AccessErrorMessage"

export const RouteErrorBoundary = () => {
	const error = useRouteError()

	if (error instanceof AccessError) {
		return <AccessErrorMessage code={error.code} errorMessage={error.errorMessage} />
	}

	return <ErrorMessage error={error as Error} />
}